
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flybilletter/[countryLevel1]/[cityLevel1]",
      function () {
        return require("private-next-pages/flybilletter/[countryLevel1]/[cityLevel1].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flybilletter/[countryLevel1]/[cityLevel1]"])
      });
    }
  